import http from '@http'
import axios from '@axios'
// 获取用户信息
export function getUserInfo() {
  return http.get('/sso/userInfo')
}

// 获取组别映射
export function getGroupMap(data) {
  return axios.post('/dictType/queryByDictType', data, { baseURL: '/ams' })
}
